import { ApplicationConfig, APP_INITIALIZER, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { LocalStorageService } from '@/core/services/local-storage';
import { SvgIconService } from '@/core/services/svgIcon/svg-icon.service';

registerLocaleData(localeRu);

function registerSvgIcons(svgIconService: SvgIconService): () => void {
  return () => svgIconService.registerIcons();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    LocalStorageService,
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    {
      provide: APP_INITIALIZER,
      useFactory: registerSvgIcons,
      deps: [SvgIconService],
      multi: true,
    },
  ],
};
